"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HitsLikeAMackTrkAbilityHandler = exports.HitsLikeAMackTrkActorAbilityFactory = exports.HitsLikeAMackTrkAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const core_1 = require("../../core/effects/core");
const Duration_1 = require("../../core/Duration");
const EventType_1 = require("../../core/events/EventType");
const Schedule_1 = require("../../core/Schedule");
const enums_1 = require("../../core/enums");
class HitsLikeAMackTrkAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.HitsLikeAMackTrk;
        this.__typeName = "HitsLikeAMackTrk";
    }
}
exports.HitsLikeAMackTrkAbilityArgs = HitsLikeAMackTrkAbilityArgs;
let HitsLikeAMackTrkActorAbilityFactory = class HitsLikeAMackTrkActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("HitsLikeAMackTrk", "Self", 0);
    }
};
HitsLikeAMackTrkActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("HitsLikeAMackTrk")
], HitsLikeAMackTrkActorAbilityFactory);
exports.HitsLikeAMackTrkActorAbilityFactory = HitsLikeAMackTrkActorAbilityFactory;
let HitsLikeAMackTrkAbilityHandler = class HitsLikeAMackTrkAbilityHandler {
    init(sequence, container, actorId) {
        container.applyBuff({
            sequence,
            creatorId: actorId,
            targetId: actorId,
            duration: Duration_1.Duration.Permanent,
            supernatural: true,
            effect: new core_1.LinkedEventHandlerEffectArgs("Hits Like a Mack Trk", "Increases damage on attack", false, container.registerEventHandlerScript(actorId, EventType_1.EventType.Attack, Schedule_1.Schedule.Unlimited, "ApplyEffect_OnAttack", {
                applyTo: Target_1.Target.Self,
                effects: [{
                        duration: Duration_1.Duration.Permanent,
                        effect: new core_1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.AllDamagePercentIncrease, 2),
                        percentChance: 100
                    }]
            }))
        });
    }
    activate(sequence, container, ability) { }
};
HitsLikeAMackTrkAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.HitsLikeAMackTrk)
], HitsLikeAMackTrkAbilityHandler);
exports.HitsLikeAMackTrkAbilityHandler = HitsLikeAMackTrkAbilityHandler;
